import type { AxiosRequestConfig } from 'axios'

import type {
  AvailableServiceItem,
  ExtendedServiceContract,
  ExtendedServiceItem,
  ServiceContractId,
  Obj,
  OrderId,
  OrganizationId,
  ProductService,
  ProductServiceId,
  BulkCreateServiceItems,
  ServiceItemId,
  ServiceItemMutator,
  ServiceItem,
} from '@beaded/models'

import * as apiUtils from '.'

const url = '/service'

//// Stripe Fetch
export const getCheckoutSession = (data: Obj): Promise<Obj> =>
  apiUtils.POST(`${url}/checkout_session`, data)

export const getCheckoutSessionStatus = (session_id: string): Promise<Obj> =>
  apiUtils.GET(`${url}/session_status/${session_id}`)

//// Service Products
export const getAllProductServices = (
  options: AxiosRequestConfig = {},
): Promise<{
  productServices: ProductService[]
}> => apiUtils.GET(`${url}/product`, options)

export const createProductService = (data: Obj) =>
  apiUtils.POST(`${url}/product`, data)

//// Service Contract
export const createServiceContract = (data: Obj) =>
  apiUtils.POST(`${url}/contract`, data)

export const createContractServicePayment = (data: Obj) =>
  apiUtils.POST(`${url}/contract/payment`, data)

export const getServiceContract = (
  id: ServiceContractId,
  options: AxiosRequestConfig = {},
): Promise<{ contract: ExtendedServiceContract }> =>
  apiUtils.GET(`${url}/contract/${id}`, options)

export const getAllServiceContracts = (
  options: AxiosRequestConfig = {},
): Promise<{ contracts: ExtendedServiceContract[] }> =>
  apiUtils.GET(`${url}/contract`, options)

export const updateServiceContract = (id: ServiceContractId, data: Obj) =>
  apiUtils.PUT(`${url}/contract/${id}`, data)

export const updateProductService = (id: ProductServiceId, data: Obj) =>
  apiUtils.PUT(`${url}/product/${id}`, data)

export const removeServiceContract = (id: ServiceContractId) =>
  apiUtils.DELETE(`${url}/contract/${id}`)

export const removeProductService = (id: ProductServiceId) =>
  apiUtils.DELETE(`${url}/product/${id}`)

export const getCurrentProductServicePrices = () =>
  apiUtils.GET(`${url}/product/current_prices`)

export const bulkCreateServiceItems = (data: BulkCreateServiceItems) =>
  apiUtils.POST('/service-item/create-bulk', data) as Promise<
    { error: string } | ServiceItem[]
  >

export const getAllServiceItems = (
  options: AxiosRequestConfig = {},
): Promise<{ serviceItems: ExtendedServiceItem[] }> =>
  apiUtils.GET('/service-item', options)

export const getAvailableServiceItems = (
  options: AxiosRequestConfig = {},
): Promise<{ serviceItems: AvailableServiceItem[] }> =>
  apiUtils.GET('/service-item/available', options)

export const getServiceItem = (
  id: ServiceItemId,
  options: AxiosRequestConfig = {},
): Promise<{ serviceItem: ExtendedServiceItem }> =>
  apiUtils.GET(`/service-item/${id}`, options)

export const updateServiceItem = (
  id: ServiceItemId,
  data: ServiceItemMutator,
) => apiUtils.PUT(`/service-item/${id}`, data)

export const verifyServiceItems = (params?: {
  orderId?: OrderId
  organizationId?: OrganizationId
  all?: string
}) => apiUtils.GET('/service-item/verify', { params })
